import { configureStore } from '@reduxjs/toolkit';
import { useDispatch, useSelector } from 'react-redux';
import combineReducer from '../reducer';
const store = configureStore({
  reducer: combineReducer,
});
export type RootState = ReturnType<typeof store.getState>;
export const useAppDispatch = () => useDispatch<typeof store.dispatch>();
export const useAppSelector = () => useSelector<typeof store.getState>;

export default store;
